import type { RelayConfig } from '../types/identity';

export interface SyncOneRelayResult {
  ok: boolean;
  newHashes: string[];
  messages: number;
  newMessages: number;
  decrypted: number;
  validated: number;
  indechiffrable: number;
  nonValide: number;
}

const ACC_KEYS: Array<keyof Omit<SyncOneRelayResult, 'ok' | 'newHashes'>> = [
  'messages',
  'newMessages',
  'decrypted',
  'validated',
  'indechiffrable',
  'nonValide',
];

export interface RunSyncLoopOpts {
  relays: RelayConfig[];
  fetchOne: (
    endpoint: string,
    start: number,
    end: number,
    serviceUuid?: string,
  ) => Promise<SyncOneRelayResult>;
  start: number;
  end: number;
  serviceUuid?: string;
}

/**
 * Iterate enabled relays, call fetchOne per relay, aggregate results.
 */
export async function runSyncLoop(opts: RunSyncLoopOpts): Promise<{
  acc: Omit<SyncOneRelayResult, 'ok' | 'newHashes'>;
  relayStatus: Array<{ endpoint: string; ok: boolean }>;
  allNewHashes: string[];
}> {
  const { relays, fetchOne, start, end, serviceUuid } = opts;
  const relayStatus: Array<{ endpoint: string; ok: boolean }> = [];
  const allNewHashes: string[] = [];
  const acc = {
    messages: 0,
    newMessages: 0,
    decrypted: 0,
    validated: 0,
    indechiffrable: 0,
    nonValide: 0,
  };
  for (const relay of relays) {
    if (!relay.enabled) {
      continue;
    }
    const one = await fetchOne(relay.endpoint, start, end, serviceUuid);
    relayStatus.push({ endpoint: relay.endpoint, ok: one.ok });
    for (const k of ACC_KEYS) {
      acc[k] += one[k];
    }
    allNewHashes.push(...one.newHashes);
  }
  return { acc, relayStatus, allNewHashes };
}
